import { useEffect, useState } from 'react';
import Logo from './Logo';

type CurrentUser = { email: string; name?: string; picture?: string } | null;

export default function Nav() {
  const [user, setUser] = useState<CurrentUser>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    fetch('/_auth/me', { credentials: 'include' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => setChecked(true));
  }, []);

  return (
    <header className="border-b-2 border-border bg-background relative z-10">
      <div className="container-ledger flex h-16 items-center justify-between">
        <div className="flex items-center gap-x-10">
          <a href="/" className="flex items-center gap-2">
            <Logo />
            <span className="font-display text-base uppercase tracking-tight">Key Receipt</span>
          </a>
          <nav className="hidden md:flex items-center gap-7">
            <a href="#how" className="text-xs uppercase tracking-wider font-bold text-muted-foreground hover:text-foreground transition-colors">How it works</a>
            <a href="#providers" className="text-xs uppercase tracking-wider font-bold text-muted-foreground hover:text-foreground transition-colors">Providers</a>
            <a href="#pricing" className="text-xs uppercase tracking-wider font-bold text-muted-foreground hover:text-foreground transition-colors">Pricing</a>
            {user && <a href="/app" className="text-xs uppercase tracking-wider font-bold text-muted-foreground hover:text-foreground transition-colors">Dashboard</a>}
          </nav>
        </div>
        <div className="flex items-center gap-4">
          {checked && user ? (
            <a
              href="/app"
              className="inline-flex items-center bg-spray-yellow text-primary-foreground px-4 py-2 text-xs font-bold uppercase tracking-wider border-2 border-foreground hover:translate-y-[-1px] transition-transform"
            >
              Open dashboard →
            </a>
          ) : (
            <>
              <a
                href="/_auth/google/login"
                className="hidden sm:inline text-xs uppercase tracking-wider font-bold text-muted-foreground hover:text-foreground"
              >
                Log in
              </a>
              <a
                href="/_auth/google/login"
                className="inline-flex items-center bg-spray-yellow text-primary-foreground px-4 py-2 text-xs font-bold uppercase tracking-wider border-2 border-foreground hover:translate-y-[-1px] transition-transform"
              >
                Start trial
              </a>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
